import Const from 'constants';

const PlayerConfirmed = {
    setPlayerConfirmedFilterFromStorage(confirmed) {
        return (dispatch) => {
            dispatch(this.setPlayerConfirmedFilter(confirmed, {countPlayers: false, saveToStorage: false}));
        };
    },

    setPlayerConfirmedFilter(confirmed, options = {}) {
        return (dispatch) => {
            const {countPlayers = true, saveToStorage = true} = options;

            confirmed = confirmed || Const.PLAYERS_CONFIRMED_FILTER_ALL;

            dispatch({
                type: Const.SET_PLAYER_CONFIRMED_FILTER,
                data: confirmed,
            });

            dispatch({
                type: Const.EXCLUDE_PLAYERS_NOT_IN_CONFIRMED_RANGE,
                confirmed,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            saveToStorage && dispatch(
                this.saveDataToStorage('playerConfirmed', function (state) {
                    const {filters} = state.playersData;

                    return filters.playerConfirmed;
                }),
            );
        };
    },
};

export default PlayerConfirmed;
